module.exports = __webpack_public_path__ + "img/chalkboard-teacher.5f932636.svg";